import axios from "axios";
import { Formik } from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { eventsActions, getEventObj } from "../../../store/events/eventsSlice";
const TeamSelectModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [teamSelected, setTeamSelected] = useState(0);
  const [teams, setTeams] = useState([]);
  const [error, setError] = useState("");
  const user = useSelector((state) => state.auth.user);
  const events = useSelector((state) => state.events);
  const selectedChoice = useSelector((state) => state.events.selectedChoice);

  const handleClose = () => {
    dispatch(eventsActions.removeEvent());
  };

  const handleEscape = () => {
    navigate("/teams");
  };

  useEffect(() => {
    const fetchTeams = () => {
      axios
        .get(
          `/api/teams/eligible-check?userId=${user.userId}&seasonId=${events.event.seasonId}`
        )
        .then((results) => {
          if (results && results.status === 200) {
            let eventChoiceObj = getEventObj(events);
            // console.log(results.data)
            let teams = results.data
            let eligibleTeams = teams.filter((t) => {
               /* check if team is actively registered to selected event and stream */
              if(t.nextEvent.length > 0) {
                const isRegistered = t.nextEvent.some(event => 
                  event.eventId === eventChoiceObj.eventId && 
                  event.eventTeamActiveId === 1
                );
                //console.log(isRegistered);
                if (isRegistered) {
                  return false;
                }
              }
            /* check if at least one member meets age category */
              const isInRange = t.members.some((m) => { 
                  const dob = moment(m.dob);
                  return dob.isSameOrAfter(moment(eventChoiceObj.endDob)) && 
                        dob.isSameOrBefore(moment(eventChoiceObj.startDob));
               });
               /* check no member is to old */
               const noMembersTooOld = t.members.every((m) => {
                  const dob = moment(m.dob);
                  return dob.isSameOrAfter(moment(eventChoiceObj.endDob)); 
              });
              return (
                eventChoiceObj.teamMin <= t.members.length &&
                eventChoiceObj.teamMax >= t.members.length &&
                /* allow younger students in the category if at least 
                one of the memebers has the correct age category*/
                isInRange &&
                noMembersTooOld
              );
            });
            setTeams(eligibleTeams);
            if (eligibleTeams.length === 0) {
              setError("No eligible teams");
            } else {
              setError("");
            }
          }
        })
        .catch(console.log);
    };
    events.event.seasonId && fetchTeams();
  }, [events, selectedChoice, user]);

  return (
    Object.keys(events.event).length > 0 &&
    Object.keys(selectedChoice).length > 0 && (
      <Modal
        show={
          Object.keys(events.event).length > 0 &&
          Object.keys(selectedChoice).length > 0
        }
        onHide={handleClose}
      >
        <Modal.Header>
          <Modal.Title>Select a Teams</Modal.Title>
        </Modal.Header>
        {error && error.length > 0 ? (
          <div className="container">
            <Modal.Body>{error}</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleEscape}>
                Create/Edit Teams
              </Button>
            </Modal.Footer>
          </div>
        ) : (
          <div className="container">
            <Formik
              initialValues={{
                teamId: 0,
              }}
              onSubmit={(values) => {
                dispatch(eventsActions.setEventTeam(teamSelected));
                navigate("/register");
              }}
            >
              {({ setFieldValue, handleSubmit }) => (
                <>
                  <Modal.Body>
                    <Form>
                      <div className="row">
                        <label>Teams</label>
                        <select
                          name="teamId"
                          className="form-select"
                          onChange={(e) => {
                            setFieldValue("teamId", parseInt(e.target.value));
                            let team = teams.filter((s) => {
                              return s.teamId === parseInt(e.target.value);
                            })[0];

                            setTeamSelected(team);
                          }}
                        >
                          <option value={0}>Select A Team...</option>
                          {teams.map((s) => {
                            return (
                              <option key={s.teamId} value={s.teamId}>
                                {s.teamName.toUpperCase()} - {s.teamCode}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Form>
                  </Modal.Body>

                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      disabled={teamSelected === 0}
                      onClick={handleSubmit}
                    >
                      Register
                    </Button>
                  </Modal.Footer>
                </>
              )}
            </Formik>
          </div>
        )}
      </Modal>
    )
  );
};

export default TeamSelectModal;
